const lead = {
  getlist: 'lead/getlist-by-admin',
  board: 'lead/board',
  summary: 'lead/summary',
  export: 'lead/export',
  get: 'lead/get',
  add: 'lead/add',
  update: 'lead/update',
  remove: 'lead/remove',
  checkmobile: 'lead/check-mobile',
  setstatus: 'lead/set-status',
  assign: 'lead/assign',
  setfollowup: 'lead/set-followup',
  addactivity: 'lead/add-activity',
  removeactivity: 'lead/remove-activity',
}
export default lead
